import { healthCheckUrl } from '@words-happen/app-urls';

/**
 * Starts the API if it has scaled to zero, so it is ready by the time the player has signed in. Returns at once: it
 * never waits for the API, never throws, and sends at most one request however often it is called.
 */
export type WarmUpApi = () => void;

/** Sends nothing: the showcase, the tests, and any build with WARM_UP_API off. */
export const noApiWarmUp: WarmUpApi = () => undefined;

/**
 * One GET /health-check on `apiOrigin`, on the first call only. The response is never read, so it goes as a no-cors
 * request without cookies; keepalive lets it reach the API even when the page leaves at once for a social provider.
 */
export const createApiWarmUp = (apiOrigin: string, fetchImpl: typeof fetch = fetch): WarmUpApi => {
  let sent = false;
  return () => {
    if (sent) {
      return;
    }
    sent = true;
    try {
      fetchImpl(healthCheckUrl(apiOrigin), {
        method: 'GET',
        mode: 'no-cors',
        credentials: 'omit',
        cache: 'no-store',
        keepalive: true,
      }).catch(() => undefined);
    } catch {
      // A fetch that throws instead of rejecting is ignored too: the warm-up must never break the page.
    }
  };
};
